import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import routes from './routes'

export { routes }

const { RouteChangeProgress } = common

export const RequirementsRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "Requirements" */ 'modules/requirements/Requirements/pages/Requirements'
    )
)
export const RequirementsGroupRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "RequirementsGroup" */ 'modules/requirements/Requirements/pages/RequirementsGroup'
    )
)

const RequirementsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={routes.root} component={RequirementsRoute} />
      <Route exact path={`${routes.group}/:groupId`} component={RequirementsGroupRoute} />
      <Redirect path='*' to={routes.root} />
    </Switch>
  </Suspense>
)

export default RequirementsRouting
